// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";

function ButtonPrimaryMobile(Props) {
  let title = Props.title;
  let onClick = Props.onClick;
  let icon = Props.icon;
  let href = Props.href;
  let tmp = {
    children: [
      JsxRuntime.jsx(Buhta_components__Text.H5.make, {
        className: "text-white",
        children: title
      }),
      icon !== undefined ? JsxRuntime.jsx("img", {
          className: "w-5 h-5",
          alt: "mobile",
          src: icon
        }) : null
    ],
    className: "bg-links hover:bg-button-primary-hover active:bg-button-primary-active rounded-sm px-3 py-2.5 flex gap-2 items-center justify-center w-full select-none hover:bg-links-hover active:bg-links-active"
  };
  if (href !== undefined) {
    tmp.href = Caml_option.valFromOption(href);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return JsxRuntime.jsxs("a", tmp);
}

const make = ButtonPrimaryMobile;

export {
  make,
}
/* Buhta_components__Text Not a pure module */
